import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CustomerLoadDocumentService,
  CustomerLoadModel,
  LoadDocumentType
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType } from '../types';

@Injectable({ providedIn: 'root' })
export class CustomerLoadDocumentApiService {
  constructor(private apiService: CustomerLoadDocumentService) {}

  public addLoadExtraDocument(loadId: string, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerLoadModel> {
    return this.apiService.customerExtraLoadDocumentAdd(loadId, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public deleteDocument(loadId: string, documentId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerLoadModel> {
    return this.apiService.customerLoadDocumentDelete(loadId, documentId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editDocument(loadId: string, documentId: string, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerLoadModel> {
    return this.apiService.customerLoadDocumentEdit(loadId, documentId, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public shareDocumentWithDriver(loadId: string, documentId: string, sharedWithDriver: boolean, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerLoadModel> {
    return this.apiService.customerLoadDocumentSharedWithDriver(loadId, documentId, sharedWithDriver, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public addLoadStopDocument(loadId: string, stopId: string, documentType: LoadDocumentType, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerLoadModel> {
    return this.apiService.customerLoadStopDocumentAdd(loadId, stopId, documentType, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
